import Vue from 'vue';
import App from './App.vue';
import router from './router';

import './assets/css/main.css';
import '@mdi/font/css/materialdesignicons.min.css';

//IMPORTAMOS VUE HIGHCHART, PARA GRÁFICAS
import VueHighcharts from 'vue-highcharts';
//DECLARAMOS LOS SETTINGS GLOBALES DE HIGHCHART:
import Highcharts from 'highcharts';
// Desde Highcharts 12 los módulos se registran solos al importarlos (exportan el objeto
// Highcharts, no una función de init): se importan solo por su efecto, en este orden
// (solid-gauge requiere highcharts-more).
import 'highcharts/highcharts-more';
import 'highcharts/modules/solid-gauge';
import 'highcharts/modules/wordcloud';
import 'highcharts/modules/map';
import 'highcharts/modules/treemap';

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy)

const   colors = ['white','green','red']

Highcharts.setOptions({
    colors: colors,
    lang: {
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        weekdays: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
        thousandsSep: '.',
        // Highcharts 7 usaba '.' por defecto; desde la 12, sin decimalPoint, formatos como
        // {percentage:.2f} siguen el locale de la página (<html lang="es"> -> coma).
        decimalPoint: '.'
    }
});
Vue.use(VueHighcharts, { Highcharts });

//ELEMENT
import element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es'
Vue.use(element, {locale});

import lodash from 'lodash';
import VueLodash from 'vue-lodash'
Vue.use(VueLodash, { name: 'custom' , lodash: lodash });

//AVATAR
import VueLetterAvatar from 'vue-letter-avatar';
Vue.use(VueLetterAvatar);

import VueInitialsImg from 'vue-initials-img';
Vue.use(VueInitialsImg);

import i18n from '@/i18n/i18n'
Vue.use(i18n)

var language = '';

if (localStorage.getItem('locale') === 'es-ES') {
    language = 'es'
} else {
    if (localStorage.getItem('locale') === 'fr-FR')
        language = 'fr'
    else
    if (localStorage.getItem('locale') === 'it-IT')
        language = 'it'
    else
    if (localStorage.getItem('locale') === 'de-DE')
        language = 'de'
    else
        language = 'en-gb'
}

// VUEMOMENT
const moment = require('moment')
require('moment/locale/'+language)
Vue.use(require('vue-moment'), {moment});


// TOUCH
var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})

//GOOGLE MAPS
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load:{
        key: 'AIzaSyCcPmT3tJq2r25QCA3YxB03pz6Z8riB8SM',
    },
    //libraries: 'places'
    installComponents: true,

})

//VUE AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'

const http = axios.create();


http.interceptors.request.use(
    (config) => {
        let token = state.token
        if (token) {
            config.headers['Authorization'] = `Bearer ${ token }`;
        }
        return config;
    },
    (error) => { return Promise.reject(error) }
);


Vue.use(VueAxios, http);
Vue.axios.defaults.baseURL = process.env.VUE_APP_BASEURL

Vue.config.productionTip = false;
import { state, actions } from '@/store';
Vue.mixin({
    data(){
        return{

        }
    },
    methods: {
        reduceBigNumbers: function(number, decimals) {
            return reduceBigNumbers(number, decimals);
        },
        numberFormat: function(number, decimals) {
            return numberFormat(number, decimals);
        }
    },
    computed:{
        periodo(){
            switch (state.period) {
                case 'month':
                    return this.$t("monthly")
                    break;
                case 'quarter':
                    return this.$t("quarterly")
                    break;
                case 'year':
                    return this.$t("annual")
                    break;
            }
        }
    }
});

Vue.filter('reduceBigNumbers', function(number, decimals) {
    return reduceBigNumbers(number, decimals)
});
Vue.filter('numberFormat', function(number, decimals) {
    return numberFormat(number, decimals)
});


export function reduceBigNumbers(number, decimals=2) {
    if (number > 1000000 || number < -1000000) {
        return numberFormat(number / 1000000, decimals) + 'M';
    }

    if (number > 1000 || number < -1000) {
        return numberFormat(number / 1000, decimals) + 'K';
    }

    return numberFormat(number, decimals);
}

export function numberFormat(number, decimals) {

    if(typeof number == 'number'){

        decimals = (decimals != undefined) ?  decimals : 2
        return parseFloat(number).toLocaleString('en', {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        }).replace(/,/g, '@').replace('.', ',').replace(/@/g, '.');
        // return parseFloat(number.toFixed(parseFloat(decimals))).toLocaleString('es-ES');
    }

}


new Vue({
    router,
    i18n,
    watch: {
        // '$route': function(to, from) {
        //     if(state.user !== null) {
        //         gtag('config', 'UA-163109359-1', {'page_path': to.fullPath,'custom_map': {'dimension1': 'usuario'}});
        //         gtag('event', 'usuario_dimension', {'usuario': state.user.id});
        //     }
        // }
    },
    render: h => h(App)
}).$mount('#app')
